import apiClient from "@/api/client";
import type { TenantVLAN, VLANCreatePayload } from "@/types/vlan";

export async function getVLANs(): Promise<TenantVLAN[]> {
  const { data } = await apiClient.get<TenantVLAN[]>("/vlans");
  return data;
}

export async function createVLAN(payload: VLANCreatePayload): Promise<TenantVLAN> {
  const { data } = await apiClient.post<TenantVLAN>("/vlans", payload);
  return data;
}

export async function deleteVLAN(vlanId: number): Promise<void> {
  await apiClient.delete(`/vlans/${vlanId}`);
}

export async function attachVM(vlanId: number, vmId: number): Promise<TenantVLAN> {
  const { data } = await apiClient.post<TenantVLAN>(`/vlans/${vlanId}/vms/${vmId}`);
  return data;
}

export async function detachVM(vlanId: number, vmId: number): Promise<void> {
  await apiClient.delete(`/vlans/${vlanId}/vms/${vmId}`);
}
